const percDiff = (A, B) => 100 * Math.abs((A - B) / ((A + B) / 2));
export default percDiff;
